<template>
  <boxwrap class="requests--inner">
    <toolbar>

      <toolbar-items class="-searchbar">
        <select-list
          ref="toolbarNav"
          class="toolbar-nav"
          :title="$route.params.status"
          v-model="selectedStatus"
        >
          <select-option
            value="all"
            name="all"
          >
              <span>all</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
              <span>deleted</span>
          </select-option>

          <select-option
            value="resolve"
            name="resolve"
          >
              <span>resolve</span>
          </select-option>

          <select-option
            value="pending"
            name="pending"
          >
              <span>pending</span>
          </select-option>

        </select-list>
        <search
          class="search-bar-wrap -withdropdown"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          v-if="selected.length > 0"
          @click="deleteItem"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          title="restore"
          v-if="selected.length > 0"
          @click="restoreItem"
        >
          <i class="ico--restore"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input type="checkbox" @click="checkAll(requests)" />
                </checkbox>
              </tbl-td>
              <tbl-td></tbl-td>
              <tbl-td
                name="id"
                :sort="true"
                @click.native="sort('id')"
                v-if="checkCol('id', tblSetting)"
              > no </tbl-td>
              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              > created at </tbl-td>
              <tbl-td
                name="title"
                :sort="true"
                @click.native="sort('title')"
                v-if="checkCol('title', tblSetting)"
              > title </tbl-td>
              <tbl-td
                name="content"
                :sort="true"
                @click.native="sort('content')"
                v-if="checkCol('content', tblSetting)"
              > content </tbl-td>
              <tbl-td
                name="reply"
                :sort="true"
                @click.native="sort('reply')"
                v-if="checkCol('reply', tblSetting)"
              > reply </tbl-td>
              <tbl-td
                name="status"
                :sort="true"
                @click.native="sort('status')"
                v-if="checkCol('status', tblSetting)"
              > status </tbl-td>
              <tbl-td
                name="admin"
                :sort="true"
                @click.native="sort('admin_id')"
                v-if="checkCol('admin', tblSetting)"
              > admin </tbl-td>
              <tbl-td
                name="login-id"
                :sort="true"
                @click.native="sort('login_id')"
                v-if="checkCol('login_id', tblSetting)"
              > login id</tbl-td>
              <tbl-td
                name="login-name"
                :sort="true"
                @click.native="sort('login_name')"
                v-if="checkCol('login_name', tblSetting)"
              > login name</tbl-td>
              <tbl-td
                name="level"
                :sort="true"
                @click.native="sort('level')"
                v-if="checkCol('level', tblSetting)"
              > level </tbl-td>
              <tbl-td
                name="agent"
                :sort="true"
                @click.native="sort('agent')"
                v-if="checkCol('agent', tblSetting)"
              > agent </tbl-td>
              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              > updated at </tbl-td>
              <tbl-td
                name="deleted-at"
                :sort="true"
                @click.native="sort('deleted_at')"
                v-if="checkCol('deleted_at', tblSetting)"
              > deleted at </tbl-td>

            </tbl-row>
          </tbl-head> <!-- tbl-head -->

          <tbl-body>
            <tbl-row
              v-for="(item, index) in requests"
              :key="item.id"
              @click.native="showModifyForm(index)"
              :class="{'is-deleted': item.deleted_at}"
            >
              <tbl-td name="checkbox">
                <checkbox
                  @click.native.stop
                >
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="item.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="status-icons"
              >
                <div
                  class="status-icon"
                  :class="{'-is-resolved': item.status === 'R'}"
                ></div>
                <div
                  class="status-icon"
                  :class="{'-is-betslip': item.betslips && item.betslips.length}"
                ></div>
              </tbl-td>

              <tbl-td
                name="id"
                v-if="checkCol('id', tblSetting)"
              >
                {{ generateNumber(index, query.page, query.rows, query.sort, requestCount || 0) }}
              </tbl-td>

              <tbl-td
                name="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ item.created_at | date }}
              </tbl-td>
              
              <tbl-td
                name="title"
                v-if="checkCol('title', tblSetting)"
                :isHtml="true"
                :logs="item.title"
              >
                <!-- {{ item.title || 'N/A' }} -->
              </tbl-td>
              <tbl-td
                name="content"
                v-if="checkCol('content', tblSetting)"
                :isHtml="true"
                :logs="item.content"
              >
                <!-- {{ item.content || 'N/A' }} -->
              </tbl-td>
              <tbl-td
                name="reply"
                v-if="checkCol('reply', tblSetting)"
                :isHtml="true"
                :logs="item.reply"
              >
                <!-- {{ item.reply || 'N/A' }} -->
              </tbl-td>
              <tbl-td
                name="status"
                v-if="checkCol('status', tblSetting)"
              >
                {{ formatStatus(item.status) }}
              </tbl-td>
              <tbl-td
                name="admin"
                v-if="checkCol('admin', tblSetting)"
              >
                <!-- {{ getLoginName(item.admin) || 'N/A' }} -->
                {{ item.admin_login_name || 'N/A' }}
              </tbl-td>
              <tbl-td
                name="login-id"
                v-if="checkCol('login_id', tblSetting)"
                @click.native.stop
                @click.native="openUser(item.user_id, 'info/undeleted')"
              >
                <!-- {{ getLoginId(item.user) || 'N/A' }} -->
                {{ item.user_login_id || 'N/A' }}

              </tbl-td>
              <tbl-td
                name="login-name"
                v-if="checkCol('login_name', tblSetting)"
                @click.native.stop
                @click.native="openUser(item.user_id, 'bet-history/all')"
              >
                <!-- {{ getLoginName(item.user) || 'N/A' }} -->
                {{ item.user_login_name || 'N/A' }}
              </tbl-td>
              <tbl-td
                name="level"
                v-if="checkCol('level', tblSetting)"
              >
                {{ item.level || 'N/A' }}
              </tbl-td>
              <tbl-td
                name="agent"
                v-if="checkCol('agent', tblSetting)"
              >
                {{ item.agents ? item.agents.agent_login_name : 'N/A' }}
              </tbl-td>
              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                <span v-if="item.reply">{{ item.updated_at | date }}</span>
                <span v-else>-</span>
              </tbl-td>
              <tbl-td
                name="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ item.deleted_at | date }}
              </tbl-td>
            </tbl-row>
          </tbl-body> <!-- tbl-body -->
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="requestCount"
            :limit="query.rows"
            v-model="query.page"
            :rows="query.rows"
            @page="trigger"
          ></pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-request"
      title="create request"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <div class="form-con">

          <div class="form-items">
            <div class="form-lbl"><span>User id</span></div>
            <div class="form-data">
              <input-suggestion
                @search="searchUser"
                v-model="requestModel.user"
                placeholder="Search User"
              >
                <span slot="selected">{{ requestModel.user ? requestModel.user.login_id : '' }}</span>
                <suggestion
                  slot="suggestion"
                  v-for="user in users"
                  :key="user.id"
                  :value="user"
                >
                  {{ user.login_id }}
                </suggestion>
              </input-suggestion>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Title</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillTitleConfig"
                  v-model="requestModel.title"
                >
                </quill-editor>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Status</span></div>
            <div class="form-data">
              <div class="input-wrap">
                 <select-list
                  :title="'pending'"
                  :withReset="true"
                  v-model="requestModel.status"
                >
                  <select-option :value="'P'">
                    Pending
                  </select-option>
                  <select-option :value="'W'">
                    Waiting
                  </select-option>
                  <select-option :value="'R'">
                    Resolved
                  </select-option>
                </select-list>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Content</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="content"
                  :options="quillContentConfig"
                  v-model="requestModel.content"
                >
                </quill-editor>
              </div>
            </div>
          </div> <!-- form-items -->

        </div> <!-- form-con-->
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="addNewRequest()"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--modify-request"
      title="reply to request"
      v-if="showModify"
      :activate="showModify"
      @activate="showModify = $event, selected = []"
    >
      <template slot="body">
        <div class="form-con">

          <div class="form-items">
            <div class="form-lbl"><span>User id</span></div>
            <div class="form-data">
              <di class="input-wrap">
                <span class="title">{{ requestUpdateModel.user_login_id }}</span>
              </di>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>User name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span class="title">{{ requestUpdateModel.user_login_name }}</span>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items" v-if="requestUpdateModel.admin_id">
            <div class="form-lbl"><span>Admin</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span class="title">{{ requestUpdateModel.admin_login_name }}</span>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Request date</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span class="title">{{ requestUpdateModel.created_at | date }}</span>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Title</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span v-html="requestUpdateModel.title"></span>
              </div>
            </div>
          </div>

          <div class="bet-history--inner">
            <div class="betslip__items">
              <betslip-card
                v-for="(slip, index) in betHistory"
                :key="betHistory.id"
                :logs="slip"
                v-if="!isDataLoading"
                @update="update($event)"
              >
                <bets-card
                  v-for="(bets, idx) in slip.userBets"
                  :key="slip.userBets.id"
                  :logs="bets"
                  v-if="slip.userBets.length > 0"
                >
                </bets-card>
              </betslip-card>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Content</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span v-html="requestUpdateModel.content"></span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl -content"><span>REPLY</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="reply"
                  :options="quillReplyConfig"
                  v-model="requestUpdateModel.reply"
                >
                </quill-editor>
              </div>
            </div>
          </div> <!-- form-items -->

        </div> <!-- form-con-->
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="saveModify()"
        >
          <i class="ico--message"></i>
          <span>send</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import { mapState, mapActions } from 'vuex'

//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

// == components
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import Modal from '@/components/base/Modal'
import Checkbox from '@/components/base/Checkbox'
import BetslipCard from '@/components/common/betslip/BetslipCard'
import BetsCard from '@/components/common/betslip/BetsCard'
import { quillEditor } from 'vue-quill-editor'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'Requests',
  components: {
    Pagination,
    Search,
    CheckDataList,
    Modal,
    Checkbox,
    BetslipCard,
    BetsCard,
    'quill-editor': quillEditor
  },

  mixins: [ getListStatus, swal, checkAll ],

  data () {
    let query = Object.assign(
      {
        page: 1,
        rows: 50,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: '',
        date_by: ''
      },
      this.$route.query
    )
    return {
      query,
      searchInput: '',
      selected: [],
      selectAll: false,
      requestList: [],
      requestModel: this.getDefaultModel(),
      requestUpdateModel: this.getDefaultModel(),
      filterStatus: 'all',
      totalDataFetch: 0,
      showCreate: false,
      showModify: false,

      // flags
      isDataLoading: false,
      showDataLoading: false,
      isEmpty: false,
      showTblSettings: false,

      filterBy: [
        {
          value: 'login_id',
          display: 'login id'
        },

        {
          value: 'login_name',
          display: 'login name'
        },

        {
          value: 'admin_id',
          display: 'admin'
        },

        {
          value: 'title',
          display: 'title'
        },

        {
          value: 'content',
          display: 'content'
        },

        {
          value: 'reply',
          display: 'reply'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      tblSetting: 'support_requests',
      allCols: [
        {
          display: 'id',
          value: 'id'
        },
        {
          display: 'title',
          value: 'title'
        },
        {
          display: 'content',
          value: 'content'
        },
        {
          display: 'reply',
          value: 'reply'
        },
        {
          display: 'admin',
          value: 'admin'
        },
        {
          display: 'login id',
          value: 'login_id'
        },
        {
          display: 'login name',
          value: 'login_name'
        },
        {
          display: 'level',
          value: 'level'
        },
        {
          display: 'agent',
          value: 'agent'
        },
        {
          display: 'status',
          value: 'status'
        },
        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'updated at',
          value: 'updated_at'
        },
        {
          display: 'deleted at',
          value: 'deleted_at'
        }
      ],

      quillTitleConfig: {
        placeholder: 'Title here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['image', 'code-block'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      quillContentConfig: {
        placeholder: 'Content here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      quillReplyConfig: {
        placeholder: 'Reply here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      }
    }
  },

  computed: {
    ...mapState('bet-history',
      ['betHistory', 'count']),
    ...mapState('support', [ 'requests', 'requestCount' ]),
    ...mapState('user', [ 'users' ]),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  watch: {
    async $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate(this.query))
    }
  },

  async created () {
    this.query = this.generate(this.query)
    this.search()
  },

  methods: {
    ...mapActions('bet-history', [ 'getAttachBetslip' ]),
    ...mapActions('support',
      [
        'createRequests',
        'getRequests',
        'updateRequests',
        'deleteRequests',
        'restoreRequests'
      ]),
    ...mapActions('meta', { getAllMeta: 'get' }),
    ...mapActions('user', { getUsers: 'get' }),

    getDefaultModel () {
      return {
        content: '',
        reply: '',
        status: 'P',
        user_id: null,
        title: '',
        user: null
      }
    },

    formatStatus (status) {
      let stat = ''
      status = status || ''
      switch (status.toUpperCase()) {
        case 'P': stat = 'Pending'
          break
        case 'W': stat = 'Waiting'
          break
        case 'R': stat = 'Resolved'
          break
        default: stat = 'N/A'
      }
      return stat
    },

    async trigger (query) {
      this.query = query || this.query
      this.$router.push({ query: this.query })
    },

    async addNewRequest () {
      let success = async () => {
        delete this.requestModel.user
        let result = await this.createRequests(this.requestModel)

        if (result.status === 201) {
          this.$alert('success', 'You have successfully created a request.', {}, '', 'Success')
          this.showCreate = false
          this.requestModel = _.assign(this.requestModel, this.getDefaultModel())
          this.$router.push({ path: '/support/requests/' })
        }
      }

      this.requestModel.user_id = this.requestModel.user.id
      this.requestModel.admin_id = parseInt(this.requestModel.admin_id, 10) || null
      this.requestModel.user_id = parseInt(this.requestModel.user_id, 10) || null

      if (this.requestModel.title === '' || this.requestModel.content === '' ||
          this.requestModel.user_id === null) {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      if (this.requestModel.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.requestModel.content.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.requestModel.user_id === null) {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create Request')
    },

    async deleteItem () {
      let success = async () => {
        let result = await this.deleteRequests(this.selected)

        if (result.status === 202) {
          this.$alert('success', 'You have successfully removed message(s).', {}, '', 'Success')
          this.selected = []
        }
      }

      this.$alert('prompt', 'Are you sure you want to remove request(s)?', {}, { success }, 'Remove Request')
    },

    async restoreItem () {
      let success = async () => {
        let result = await this.restoreRequests(this.selected)

        if (result.status === 204) {
          this.$alert('success', 'You have successfully restored message(s).', {}, '', 'Success')
          this.selected = []
        }
      }

      this.$alert('prompt', 'Are you sure you want to restore request(s)?', {}, { success }, 'Restore Request')
    },

    async search (query) {
      this.query = query || this.query
      this.filterStatus = this.$route.params.status

      this.selected = []

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getRequests({ status: this.filterStatus, params: this.query })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.requests.length) {
        this.isEmpty = true
      }
    },

    async showModifyForm (index) {
      if (this.checkPermission) {
        const item = this.requests[index]
        this.selected.push(item.id)
        this.requestUpdateModel = _.assign(this.requestUpdateModel, item)
        console.log(this.requestUpdateModel)
        await this.getAttachBetslip({
          request_id: this.requestUpdateModel.id
        })
        this.showModify = true
      }
    },

    async saveModify () {
      let success = async () => {
        let result = await this.updateRequests(this.requestUpdateModel)

        this.getAllMeta()

        if (result.status === 204) {
          this.$alert('success', 'You have successfully replied the request.', {}, '', 'Success')
          this.selected = []
          this.requestUpdateModel = this.getDefaultModel()
          this.showModify = false
          this.search()
        }
      }

      if (this.requestUpdateModel.title === '' || this.requestUpdateModel.content === '') {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      if (this.requestUpdateModel.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.requestUpdateModel.content.replace(/(<([^>]+)>)/ig, ' ').trim() === '') {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to reply request?', {}, { success }, 'Reply Request')
    },

    async searchUser (q) {
      let params = { rows: 50, sortBy: 'id', sort: 'asc' }

      if (q) {
        params.filter_by = 'login_id'
        params.q = q
      }

      await this.getUsers({
        status: 'confirmed',
        params: params
      })
    },

    sort (sortBy) {
      if (this.query.sort === 'asc') {
        this.query.sort = 'desc'
      } else {
        this.query.sort = 'asc'
      }

      this.query.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    },

    openUser (id, subtype) {
      window.open(
        `${process.env.VUE_APP_URL}/user/${id}/${subtype}`,
        '',
        `width=${1400},height=${window.innerHeight}`
      )
    }
  }
}
</script>

<style scoped>
  input[type=checkbox] {
    width: 14px;
    height: 14px;
    border: 1px solid #a4a7a7;
  }

  input[type=checkbox]:checked {
    background: rgb(236, 2, 166);
  }

  .filter {
    display: flex;
    list-style: none;
  }

  .filter li {
    margin-right: 4px;
  }
</style>
